import openInNewSvg from "./openInNew.svg"

export const openInNewIcon = openInNewSvg
